import { Avatar, Box, Stack, Typography } from '@mui/material';
import PWDKIconButton from 'components/new/PWDKIconButton';
import React, { useMemo, useState } from 'react';
import { appConfig } from 'utils/config';
import { Check, Close, Delete } from '@mui/icons-material';
import ApproveRemoveModal from './Modal/ApproveRemoveModal';
import RejectModal from './Modal/RejectModal';

const MemberList = ({ tribeMembers, activeTab, refetch }) => {
  const [approveRemoveModal, setApproveRemoveModal] = useState({
    open: false,
    type: '',
  });
  const [rejectModal, setRejectModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState('');

  const memberToShow = useMemo(() => {
    const showApprovedMember = activeTab === 'member';
    return tribeMembers?.filter(
      ({ approved }) => approved === showApprovedMember,
    );
  }, [activeTab, tribeMembers]);

  const selectedMemberData = useMemo(() => {
    return tribeMembers?.find(({ id }) => id === selectedUserId);
  }, [selectedUserId, tribeMembers]);

  if (activeTab === 'request' && !memberToShow.length) {
    return (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        mt={{ md: 3, xs: 2 }}
      >
        <Typography
          py={{ md: 3, xs: 2 }}
          typography={{ md: 'paragraph', xs: 'paragraph2' }}
        >
          You have no member requests.
        </Typography>
      </Stack>
    );
  }

  return (
    <Box mt={{ md: 3, xs: 2 }}>
      <Stack
        spacing={2}
        sx={{
          height: '284px',
          overflowY: 'scroll',
          '::-webkit-scrollbar': {
            width: '4px',
          },
          '::-webkit-scrollbar-track': {
            background: '#F0F0F0',
          },
          '::-webkit-scrollbar-thumb': {
            background: '#D9D9D9',
          },
        }}
      >
        {React.Children.toArray(
          memberToShow?.map(
            ({ id, nameMember, profilePictureMember, user: { phone } }) => (
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                pr={{ md: '16px', xs: '11px' }}
              >
                <Stack
                  direction="row"
                  spacing={{ md: '16px', xs: '12px' }}
                  alignItems="center"
                >
                  <Avatar
                    src={`${appConfig.baseUrl}${profilePictureMember}`}
                    alt={nameMember}
                    sx={{
                      width: { md: '40px', xs: '30px' },
                      height: { md: '40px', xs: '30px' },
                      borderRadius: '100%',
                    }}
                  />
                  <Stack spacing={0.5}>
                    <Typography
                      typography={{ md: 'subheading3medium', xs: 'caption1' }}
                      color="neutral100.main"
                    >
                      {nameMember}
                    </Typography>
                    <Typography
                      typography={{
                        md: 'captionreguler',
                        xs: 'metatagreguler',
                      }}
                      color="neutral400.main"
                    >
                      {phone}
                    </Typography>
                  </Stack>
                </Stack>
                {activeTab === 'request' ? (
                  <Stack direction="row" spacing={2}>
                    <PWDKIconButton color="success300.main">
                      <Check
                        fontSize="small"
                        onClick={() => {
                          setSelectedUserId(id);
                          setApproveRemoveModal({
                            open: true,
                            type: 'approve',
                          });
                        }}
                      />
                    </PWDKIconButton>
                    <PWDKIconButton color="error300.main">
                      <Close
                        fontSize="small"
                        onClick={() => {
                          setSelectedUserId(id);
                          setRejectModal(true);
                        }}
                      />
                    </PWDKIconButton>
                  </Stack>
                ) : (
                  <PWDKIconButton color="neutral400.main">
                    <Delete
                      fontSize="small"
                      onClick={() => {
                        setSelectedUserId(id);
                        setApproveRemoveModal({
                          open: true,
                          type: 'remove',
                        });
                      }}
                    />
                  </PWDKIconButton>
                )}
              </Stack>
            ),
          ),
        )}
      </Stack>
      <ApproveRemoveModal
        open={approveRemoveModal.open}
        onClose={() =>
          setApproveRemoveModal({
            open: false,
            type: approveRemoveModal.type,
          })
        }
        type={approveRemoveModal.type}
        tribeMemberData={selectedMemberData}
        refetch={refetch}
      />
      <RejectModal
        open={rejectModal}
        onClose={() => setRejectModal(false)}
        tribeMemberData={selectedMemberData}
        refetch={refetch}
      />
    </Box>
  );
};

export default MemberList;
